import SiafLiteApiRepository from "../../external/siafLiteApi";

class ConfiguracoesService {
  constructor() {
    this.urlBase = "/painel-controle/configuracoes";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  get() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  getJurosMulta() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/juros-multa`).get();
  }
}

export default ConfiguracoesService;
